import { learningServiceRequest } from "./utils";

const sessionTypesService = {
  async list(search) {
    const { data: response } = await learningServiceRequest({
      method: "get",
      url: "/programming/session_types",
      params: { limit: 150, q: search },
      failureMessage: "Error loading Cip Codes",
    });
    return response?.data?.items ?? [];
  },
};

export default sessionTypesService;
